import React, { useState, useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import TablePagination from "@mui/material/TablePagination";
import {
  Container,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  Box,
  Typography,
  CircularProgress,
  Backdrop,
} from "@mui/material";
import { Logout, RemoveRedEye } from "@mui/icons-material";

import api from "../services/api";
import { clearLocalStorage, getLocalStorage } from "../utils/auth";
import { useDispatch, useSelector } from "react-redux";
import {
  setDashboardPageNumber,
  setFilesPartsEmpty,
} from "../slice/searchPaginationSlice";

import * as XLSX from "xlsx";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";

const StudentLists = () => {
  const navigate = useNavigate();
  const { schoolId } = useParams();
  const location = useLocation();
  const { agencyName } = location?.state || "";
  const [loading, setLoading] = useState(true);
  const [fileUploadLoading] = useState(false);
  const [dashboardList, setDashboardList] = useState([]);
  const [count, setCount] = useState(0);

  const [downloadCSVLoading, setDownloadCSVLoading] = useState(false);

  const [rowsPerPage] = useState(50);

  const { dashboardPageNumber, dashboardSearchValue, fileType } = useSelector(
    (store) => store.searchPagination
  );

  const dispatch = useDispatch();
  const [searchQuery, setSearchQuery] = useState(
    dashboardSearchValue ? dashboardSearchValue : ""
  );
  useEffect(() => {
    if (schoolId) {
      dashboardData();
    }
  }, [schoolId]);
  let handler;

  useEffect(() => {
    return () => {
      clearTimeout(handler);
    };
  }, []);

  // const [page, setPage] = useState(0);
  // const [searchQuery, setSearchQuery] = useState("");
  // const [debouncedQuery, setDebouncedQuery] = useState("");

  const userInfo = getLocalStorage("user")
    ? JSON.parse(getLocalStorage("user"))
    : null;

  const dashboardData = async (number, search = "", type = fileType) => {
    try {
      setDownloadCSVLoading(true);
      //   let apiPath = `compartment/data/?search=${
      //     search || searchQuery
      //   }&limit=50&offset=${50 * (number ?? dashboardPageNumber)}`;

      // let apiPath = `compartment/form-data/${schoolId}/?limit=10&offset=0`;
      let apiPath = `compartment/data?search=Paid&schoolCode=${schoolId}`;

      // if (type) {
      //   apiPath = `compartment/form-data?limit=10&offset=4/${schoolId}/${type}/?search=${
      //     search || searchQuery
      //   }&limit=50&offset=${50 * (number ?? dashboardPageNumber)}`;
      // }
      const response = await api.get(apiPath);
      // console.log(response, "response");
      setDashboardList(response?.data?.data);
      setCount(response?.data?.data?.count);
      // setDashboardList(response?.data?.count);
    } catch (error) {
      toast.error(
        error?.response?.data?.error ?? "Error fetching data. Please try again."
      );
    } finally {
      setLoading(false);
      setDownloadCSVLoading(false);
    }
  };

  const handleChangePage = (event, newPage) => {
    dispatch(setDashboardPageNumber(newPage));
  };

  const formatCustomDate = (date) => {
    if (!date) return "-";

    const d = new Date(date);
    const day = String(d.getDate()).padStart(2, "0");
    const month = d.toLocaleString("en-US", { month: "short" });
    const year = d.getFullYear();
    const time = d.toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: true,
    });

    return `${day}-${month}-${year} ${time}`;
  };

  const handleRowClick = (item) => {
    navigate(`/student-details/${item?.id}`, {
      state: {
        details: item,
        schoolId: schoolId,
        schoolName: agencyName,
      },
    });
  };

  const logoutUser = () => {
    clearLocalStorage();
    navigate("/login");
  };

  const exportToPDF = () => {
    const doc = new jsPDF();

    // Adding a title
    doc.text("Candidate List", 14, 10);

    autoTable(doc, {
      startY: 20,
      head: [
        [
          "#",
          "BSEB Unique ID",
          "Reg.No",
          "Amount Paid",
          "Candidate Details",
          "DOB / Caste / Applied Ctg",
          "Action",
        ],
      ],
      body: dashboardList.map((item, index) => [
        index + 1,
        item.uniqid || "N/A",
        item.o_reg || "N/A",
        item.compartmentFormRequest_data?.fee_amount || "N/A",
        `${item.nm || ""} / ${item.mnm || ""} / ${item.fnm || ""} / ${
          item.sex || ""
        } / ${item.exam_type || ""}`,
        `${item.dob || ""} / ${item.caste || ""} / ${item.applycat || ""}`,
        `${
          item?.compartmentFormRequest_data?.other_data
            ? "Applied"
            : "Not Applied"
        }`,
      ]),
    });

    doc.save("Candidate_List.pdf");
  };

  const exportToExcel = () => {
    if (!dashboardList || dashboardList.length === 0) {
      console.error("No data available for export");
      return;
    }

    const headers = [
      [
        "#",
        "BSEB Unique ID",
        "Reg.No",
        "Amount Paid",
        "Candidate Details",
        "DOB / Caste / Applied Ctg",
        "Action",
      ],
    ];

    const data = dashboardList.map((item, index) => [
      index + 1,
      item.uniqid || "N/A",
      item.o_reg || "N/A",
      item.compartmentFormRequest_data?.fee_amount || "N/A",

      `${item.nm || ""} / ${item.mnm || ""} / ${item.fnm || ""} / ${
        item.sex || ""
      } / ${item.exam_type || ""}`,
      `${item.dob || ""} / ${item.caste || ""} / ${item.applycat || ""}`,
      `${
        item?.compartmentFormRequest_data?.other_data
          ? "Applied"
          : "Not Applied"
      }`,
    ]);

    const worksheet = XLSX.utils.aoa_to_sheet([...headers, ...data]);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Candidates");

    XLSX.writeFile(workbook, "Candidate_List.xlsx");
  };

  const exportToCSV = () => {
    const csvContent = [
      "# , BSEB Unique ID , Reg.No ,Amount Paid, Candidate Details , DOB / Caste / Applied Ctg, Action",
      ...dashboardList.map((item, index) =>
        [
          index + 1,
          item.uniqid,
          item.o_reg,
          item.compartmentFormRequest_data?.fee_amount,
          `${item.nm || ""} / ${item.mnm || ""} / ${item.fnm || ""} / ${
            item.sex || ""
          } / ${item.exam_type || ""}`,
          `${item.dob || ""} / ${item.caste || ""} / ${item.applycat || ""}`,
          `${
            item?.compartmentFormRequest_data?.other_data
              ? "Applied"
              : "Not Applied"
          }`,
        ].join(",")
      ),
    ].join("\n");
    const blob = new Blob([csvContent], { type: "text/csv" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = "table.csv";
    link.click();
  };

  const handlePrint = () => {
    window.print();
  };

  //console.log(selectBox, "selectBox");
  if (loading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="100vh"
      >
        <CircularProgress />
      </Box>
    );
  }
  return (
    <>
      {/* Image Section */}
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        mb={1}
        mt={2}
      >
        <Box textAlign="center">
          <img
            src="../full-logo.png"
            alt="Bihar Board Examination"
            title="Bihar Board Examination"
            style={{ maxWidth: "100%", height: "68px" }}
          />
        </Box>
      </Box>
      <div style={{ height: "54px", backgroundColor: "#8C0001" }} />
      <Container maxWidth="lg" style={{ marginTop: "24px" }}>
        {fileUploadLoading ? (
          <Backdrop
            open={fileUploadLoading}
            style={{ zIndex: 9999, color: "#fff" }}
          >
            <CircularProgress color="inherit" />
          </Backdrop>
        ) : null}

        <Box
          // display="flex"
          // flexWrap="wrap"
          gap="10px"
          // justifyContent="space-between"
          alignItems="center"
          // flexDirection="row"
          mb={3}
        >
          <Box
            display="flex"
            justifyContent="space-between"
            sx={{ marginBottom: "10px", width: "91%" }}
          >
            <Typography
              variant="h4"
              sx={{
                fontSize: { xs: "1.3rem", sm: "1.5rem", md: "1.8rem" },
              }}
            >
              {userInfo?.employeeName} {""}
              {agencyName} Students Report
            </Typography>
          </Box>
          <Box display="flex" flexWrap="wrap" alignItems="center" gap={2}>
            {/* <TextField
              id="standard-basic"
              label="Search..."
              variant="outlined"
              // onChange={(e) => setSearchQuery(e.target.value)}
              onChange={(e) => handleSearch(e.target.value)}
              value={searchQuery}
              size="small"
              InputProps={{
                endAdornment: searchQuery && (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() => {
                        handleSearch("");
                      }}
                      edge="end"
                      size="small"
                    >
                      <ClearIcon />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            /> */}
            {/* <Button
              variant="contained"
              color="primary"
              onClick={searchRecord}
              style={{
                textTransform: "none",
                backgroundColor: "#8C0001",
              }}
            >
              Search
            </Button> */}
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                navigate("/dashboard");

                dispatch(setFilesPartsEmpty());
              }}
              style={{ textTransform: "none" }}
            >
              Back to Dashboard
            </Button>

            {/* {selectedRows?.length > 1 && (
              // <Button
              //   variant="text"
              //   color="primary"
              //   style={{
              //     textTransform: "none",
              //     color: "#8C0001",
              //     borderColor: "#8C0001",
              //   }}
              //   startIcon={<Download />}
              //   onClick={handleMultiDownLoad}
              // >
              //   Download Files
              // </Button>

              <Button
                onClick={handleMultiDownLoad}
                variant="outlined"
                // disabled={true}
                startIcon={<Download />}
                style={{ color: "#8C0001", borderColor: "#8C0001" }}
              >
                Download Consolidated Files
              </Button>
            )} */}

            <Button
              variant="contained"
              color="error"
              startIcon={<Logout />}
              onClick={logoutUser}
              style={{ textTransform: "none", marginLeft: "auto" }}
            >
              Logout
            </Button>
          </Box>
        </Box>
        <Box
          style={{
            marginBottom: "5px",
          }}
          sx={{ mt: 2, display: "flex", gap: 1 }}
        >
          <Button variant="contained" onClick={handlePrint}>
            Print
          </Button>
          {/* <Button variant="contained">Copy</Button> */}
          <Button variant="contained" onClick={exportToCSV}>
            CSV
          </Button>
          <Button variant="contained" onClick={exportToExcel}>
            Excel
          </Button>
          <Button variant="contained" onClick={exportToPDF}>
            PDF
          </Button>
          <Typography
            style={{
              marginLeft: "auto",
            }}
          >
            Total Paid Students: {dashboardList?.length}
          </Typography>
        </Box>

        {/* <AppBar
          position="static"
          sx={{ backgroundColor: "white", boxShadow: "none" }}
        >
          <Tabs
            value={selectedTab}
            onChange={handleChange}
            variant="scrollable"
            scrollButtons="auto"
          >
            {agencies.map((agency, index) => (
              <Tab
                key={index}
                label={agency}
                sx={{
                  fontSize: "10px",
                }}
              />
            ))}
          </Tabs>
        </AppBar> */}

        <TableContainer
          sx={{
            // maxHeight: "65vh",
            // mt: 4,
            // border: "1px solid black",

            overflowY: "scroll", // Ensure scrollbar is always visible
            scrollbarWidth: "thin", // Firefox support
            "&::-webkit-scrollbar": {
              width: "8px", // Chrome & Safari
            },
            "&::-webkit-scrollbar-thumb": {
              background: "#888", // Color of scrollbar
              borderRadius: "4px",
            },
            "&::-webkit-scrollbar-thumb:hover": {
              background: "#555",
            },

            maxHeight: "65vh",
            overflow: "auto",
            mt: 2,
            width: "99.90%",
            border: "1px solid black",
            borderBottom: "0px",
            borderRight: "none",
          }}
          // sx={{ maxHeight: "58vh", overflow: "auto" }}
          component={Paper}
        >
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell
                  className="card-title"
                  sx={{
                    borderRight: "1px solid #000",
                    borderBottom: "1px solid #000",
                  }}
                >
                  #
                </TableCell>
                <TableCell
                  className="card-title"
                  style={{ minWidth: "110px" }}
                  sx={{
                    borderRight: "1px solid #000",
                    borderBottom: "1px solid #000",
                  }}
                >
                  BSEB Unique ID
                </TableCell>
                <TableCell
                  className="card-title"
                  style={{ minWidth: "60px" }}
                  sx={{
                    borderRight: "1px solid #000",
                    borderBottom: "1px solid #000",
                  }}
                >
                  Reg.No
                </TableCell>
                <TableCell
                  className="card-title"
                  style={{ minWidth: "60px" }}
                  sx={{
                    borderRight: "1px solid #000",
                    borderBottom: "1px solid #000",
                  }}
                >
                  Amount Paid
                </TableCell>
                <TableCell
                  className="card-title"
                  style={{ minWidth: "380px" }}
                  sx={{
                    borderRight: "1px solid #000",
                    borderBottom: "1px solid #000",
                  }}
                >
                  Candidate’s Name/Mother’s Name/Father’s Name / sex / Exam Type
                </TableCell>
                <TableCell
                  className="card-title"
                  style={{ minWidth: "210px" }}
                  sx={{
                    borderRight: "1px solid #000",
                    borderBottom: "1px solid #000",
                  }}
                >
                  D-O-B / Caste / Applied Ctg
                </TableCell>
                <TableCell
                  className="card-title"
                  sx={{
                    borderRight: "1px solid #000",
                    borderBottom: "1px solid #000",
                  }}
                >
                  Action
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {dashboardList?.length > 0 ? (
                dashboardList?.map((row, index) => (
                  <TableRow className="tableBody_styles">
                    <TableCell className="card-title">{index + 1}</TableCell>
                    <TableCell className="card-title">{row?.uniqid}</TableCell>
                    <TableCell className="card-title">{row?.o_reg}</TableCell>
                    <TableCell className="card-title">
                      {row?.compartmentFormRequest_data?.fee_amount}
                    </TableCell>
                    <TableCell className="card-title">
                      {/* {row?.student_name} / {row?.mnm} /{" "}
                            {row?.fnm} /{" "} */}
                      {row?.nm ? `${row?.nm}` : ""}
                      {row?.mnm ? `${row?.nm ? "/" : ""} ${row?.mnm} ` : ""}
                      {row?.fnm ? `${row?.mnm ? "/" : ""} ${row?.fnm} ` : ""}
                      {row?.sex ? `${row?.fnm ? "/" : ""} ${row?.sex} ` : ""}
                      {row?.exam_type
                        ? `${row?.sex ? "/" : ""}  ${row?.exam_type}`
                        : ""}
                      {row?.applycat
                        ? `${row?.sex ? "/" : ""}  ${
                            row?.applycat === "C" ? "Compartment" : "Special"
                          }`
                        : ""}
                      {/* {row?.fr
                    } */}
                    </TableCell>
                    <TableCell className="card-title">
                      {/* {row?.dob} / {row?.caste} / {row?.applycat} */}
                      {row?.dob ? `${row?.dob}` : ""}
                      {row?.caste
                        ? ` ${row?.dob ? "/" : ""} ${row?.caste} `
                        : ""}
                      {row?.applycat
                        ? `${row?.caste ? "/" : ""}  ${
                            row?.applycat === "C"
                              ? "Compartment"
                              : row?.applycat === "E"
                              ? "Ex-Student"
                              : row?.applycat === "B"
                              ? "Betterment"
                              : row?.applycat === "R"
                              ? "Reg/Pvt"
                              : row?.applycat === "Single Subject (English)"
                              ? "Single Subject (English)"
                              : row?.applycat === "Opt. Prac"
                              ? "Opt. Prac"
                              : "_"
                          } `
                        : ""}
                    </TableCell>
                    <TableCell xs={{ borderRight: "3px solid #000" }}>
                      <Button
                        variant="contained"
                        sx={{
                          mt: 2,
                          backgroundColor: row?.compartmentFormRequest_data
                            ?.other_data
                            ? "green"
                            : "#007bff",
                          color: "white",
                        }}
                        // disabled={!ids?.includes(item?.id?.toString())}
                        onClick={() => handleRowClick(row)}
                        startIcon={
                          row?.compartmentFormRequest_data?.other_data && (
                            <RemoveRedEye />
                          )
                        }
                      >
                        {row?.compartmentFormRequest_data?.other_data
                          ? "Applied"
                          : " Not Applied"}
                      </Button>
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={5} style={{ textAlign: "center" }}>
                    No records found
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        {/* <TablePagination
          // rowsPerPageOptions={[5, 10, 25, 30]}
          rowsPerPageOptions={undefined}
          component="div"
          count={count}
          rowsPerPage={rowsPerPage}
          page={dashboardPageNumber}
          onPageChange={handleChangePage}

          // onRowsPerPageChange={handleChangeRowsPerPage}
        /> */}
      </Container>

      {/* Loader Backdrop */}
      <Backdrop
        open={downloadCSVLoading}
        style={{ zIndex: 1300, color: "#fff" }}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  );
};

export default StudentLists;
